export const pagesTestAssetsEn = {
  detail: {
    options: {
      testAssetExecutionType: {
        AUTOMATED: 'Automated',
        MANUAL: 'Manual',
        SEMI_AUTOMATED: 'Semi-automated'
      },
      testAssetKind: {
        ACCESSIBILITY: 'Accessibility',
        COMPATIBILITY: 'Compatibility',
        E2E: 'E2E',
        EXPLORATORY: 'Exploratory',
        FUNCTIONAL: 'Functional',
        INTEGRATION: 'Integration',
        OTHER: 'Other',
        PERFORMANCE: 'Performance',
        REGRESSION: 'Regression',
        SECURITY: 'Security',
        SMOKE: 'Smoke',
        SYSTEM: 'System',
        UNIT: 'Unit',
        USABILITY: 'Usability'
      },
      testAssetStatus: {
        ACTIVE: 'Active',
        IN_MAINTENANCE: 'In Maintenance',
        LEGACY: 'Legacy'
      }
    }
  },
  list: {
    columns: {
      defectCount: 'Defects Found',
      executionType: 'Execution',
      kind: 'Kind',
      lastExecutedAt: 'Last Executed',
      module: 'Module',
      name: 'Name',
      owner: 'Owner',
      product: 'Product',
      status: 'Status',
      version: 'Version'
    },
    filterPlaceholder: 'Search by name',
    filters: {
      archivedHidden: 'Archived: hidden',
      archivedShown: 'Archived: shown'
    },
    noResults: 'No test assets matched the current filter.',
    pageTitle: 'Test Assets',
    tabs: {
      active: 'Active',
      all: 'All',
      inMaintenance: 'In Maintenance',
      legacy: 'Legacy'
    }
  }
};